module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row mx-1"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-md-12 mb-3"
  }, [_c('div', {
    staticClass: "d-flex align-items-start justify-content-between my-2"
  }, [_c('label', {
    staticClass: "full fs-large darker m-0"
  }, [_vm._v("How would you like to set the price for this group?")]), _vm._v(" "), _c('button', {
    staticClass: "btn-learn-more bold pointer fs-large ml-3 text-nowrap m-0",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.openLearnMoreModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Learn More")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column justify-content-between mt-3 col-12 col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('radio', {
    staticClass: "mb-1 mr-2",
    class: {
      'notAllowed': _vm.disabled
    },
    attrs: {
      "value": 1,
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.changePriceType
    },
    model: {
      value: (_vm.group.passengerSettings.format),
      callback: function($$v) {
        _vm.$set(_vm.group.passengerSettings, "format", $$v)
      },
      expression: "group.passengerSettings.format"
    }
  }, [_vm._v("\n                        Price per Person\n                    ")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Each person pays this amount individually, but the price depends on the number of people'),
      expression: "'Each person pays this amount individually, but the price depends on the number of people'"
    }],
    staticClass: "fa fa-info-circle fs-normal dark mt-1"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('radio', {
    staticClass: "mb-1 mr-2",
    class: {
      'notAllowed': _vm.disabled
    },
    attrs: {
      "value": 0,
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.changePriceType
    },
    model: {
      value: (_vm.group.passengerSettings.format),
      callback: function($$v) {
        _vm.$set(_vm.group.passengerSettings, "format", $$v)
      },
      expression: "group.passengerSettings.format"
    }
  }, [_vm._v("\n                        Price per Group\n                    ")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('The group pays this amount regardless of the number of people'),
      expression: "'The group pays this amount regardless of the number of people'"
    }],
    staticClass: "fa fa-info-circle fs-normal dark mt-1"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('radio', {
    staticClass: "mr-2",
    class: {
      'notAllowed': _vm.disabled
    },
    attrs: {
      "value": 2,
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.changePriceType
    },
    model: {
      value: (_vm.group.passengerSettings.format),
      callback: function($$v) {
        _vm.$set(_vm.group.passengerSettings, "format", $$v)
      },
      expression: "group.passengerSettings.format"
    }
  }, [_vm._v("\n                        Price per Category Tier\n                    ")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Each person pays this amount individually, but the price depends on the number of people per category'),
      expression: "'Each person pays this amount individually, but the price depends on the number of people per category'"
    }],
    staticClass: "fa fa-info-circle fs-normal dark mt-1"
  })], 1)])])]), _vm._v(" "), _c('h5', {
    staticClass: "mt-2 mb-4 p-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "row mx-1"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-md-12"
  }, [_c('table', {
    staticClass: "table narrow"
  }, [(true) ? _c('thead', [_c('tr', {
    staticClass: "thead-size"
  }, [_c('th', {
    staticClass: "border-top-0 border-left-0 border-bottom border-right text-center",
    attrs: {
      "width": "35%"
    }
  }, [_vm._v("Number of People")]), _vm._v(" "), _c('th', {
    staticClass: "border-top-0 border-right-0 border-bottom text-center",
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Tax")]), _vm._v(" "), _c('th', {
    staticClass: "border-top-0 border-right-0 border-bottom text-center",
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Price")]), _vm._v(" "), _c('th', {
    staticClass: "border-top-0 border-right-0 border-bottom text-center",
    attrs: {
      "width": "10%"
    }
  }, [_c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Edit'),
      expression: "'Edit'"
    }],
    staticClass: "fas fa-calculator fs-large medium pointer",
    class: {
      'dark': _vm.hasDecomposedPrices,
      'notAllowed': (_vm.disabled && !_vm.hasDecomposedPrices) || _vm.hasPriceErrorsDueResources
    },
    on: {
      "click": function($event) {
        return _vm.openEditPrice()
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('tbody', [_vm._l((_vm.pricePerGroupPrices), function(priceConfig, idx) {
    return _c('tr', {
      class: {
        'more-than-allowed': _vm.moreThanAllowed(priceConfig, idx) || _vm.hasPriceGroupDecompositionError(priceConfig)
      }
    }, [_c('td', {
      staticClass: "border-right default-cursor"
    }, [_c('div', {
      staticClass: "d-flex align-items-center justify-content-center my-1"
    }, [_c('span', {
      staticClass: "mr-3 fs-normal bold darker"
    }, [_vm._v(_vm._s(priceConfig.lowerBound))]), _vm._v(" "), _c('span', {
      staticClass: "mr-3 fs-normal darker"
    }, [_vm._v("to")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (priceConfig.upperBound),
        expression: "priceConfig.upperBound",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "text-center fs-normal",
      staticStyle: {
        "height": "1.8rem",
        "width": "3.2rem"
      },
      attrs: {
        "type": "number",
        "disabled": _vm.disabled || _vm.hasPriceErrorsDueResources
      },
      domProps: {
        "value": (priceConfig.upperBound)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(priceConfig, "upperBound", _vm._n($event.target.value))
        }, function($event) {
          return _vm.debouncedUpdatePeopleNumber(idx, $event.target.valueAsNumber)
        }],
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "default-cursor"
    }, [_c('div', {
      staticClass: "d-flex justify-content-center align-items-center mx-2"
    }, [_c('v-select', {
      staticClass: "ppg-smaller-select",
      class: {
        'pointer': !_vm.disabled || !_vm.hasPriceErrorsDueResources,
        'notAllowed': _vm.disabled || _vm.hasPriceErrorsDueResources
      },
      attrs: {
        "options": _vm.taxes,
        "value": _vm.getTaxValue(priceConfig.vat),
        "label": "description",
        "placeholder": "Select tax",
        "disabled": _vm.disabled || _vm.hasPriceErrorsDueResources
      },
      on: {
        "input": function($event) {
          return _vm.updateTaxVal($event, priceConfig)
        }
      }
    })], 1)]), _vm._v(" "), _c('td', {
      staticClass: "default-cursor"
    }, [_c('div', {
      staticClass: "d-flex justify-content-center align-items-center mx-4"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (priceConfig.price),
        expression: "priceConfig.price",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "glued-right pr-0 w-80",
      staticStyle: {
        "max-width": "4rem",
        "height": "1.8rem"
      },
      attrs: {
        "disabled": _vm.disabled || _vm.hasPriceErrorsDueResources,
        "type": "number"
      },
      domProps: {
        "value": (priceConfig.price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(priceConfig, "price", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "glued-left p-1 pr-2",
      staticStyle: {
        "height": "1.8rem"
      }
    }, [_vm._v("€")])])]), _vm._v(" "), _c('td', {
      staticClass: "default-cursor"
    }, [_c('div', {
      staticClass: "d-flex align-items-center",
      class: {
        'justify-content-center': !_vm.hasDecomposedPrices,
        'justify-content-between': _vm.hasDecomposedPrices
      }
    }, [(_vm.hasDecomposedPrices) ? _c('i', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: (_vm.priceConfigInfo(priceConfig)),
        expression: "priceConfigInfo(priceConfig)"
      }],
      staticClass: "fa fa-info-circle fs-normal darker",
      class: {
        'color-6': _vm.hasPriceGroupDecompositionError(priceConfig)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pricePerGroupPrices.length > 1) ? _c('i', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ('Remove'),
        expression: "'Remove'"
      }],
      staticClass: "ico-delete fs-large medium",
      class: {
        'pointer': !_vm.disabled || !_vm.hasPriceErrorsDueResources,
        'notAllowed': _vm.disabled || _vm.hasPriceErrorsDueResources
      },
      on: {
        "click": function($event) {
          return _vm.removePriceConfig(idx)
        }
      }
    }) : _vm._e()])])])
  }), _vm._v(" "), _c('tr', {
    staticStyle: {
      "height": "40px"
    }
  }, [_c('td', {
    staticClass: "border-top default-cursor",
    class: {
      'border-right': !_vm.hasPriceErrors
    }
  }, [(!_vm.hasPriceErrors) ? _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('div', {
    staticClass: "d-flex align-items-center bold",
    class: {
      'pointer': !_vm.disabled || !_vm.hasPriceErrorsDueResources,
      'notAllowed': _vm.disabled || _vm.hasPriceErrorsDueResources
    },
    on: {
      "click": function($event) {
        return _vm.addPriceConfig()
      }
    }
  }, [_c('i', {
    staticClass: "ico-add fs-smallest add-circle color-1"
  }), _vm._v(" Add\n                                ")])]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "border-top default-cursor"
  }), _vm._v(" "), _c('td', {
    staticClass: "border-top default-cursor"
  }), _vm._v(" "), _c('td', {
    staticClass: "border-top default-cursor"
  })])], 2)]), _vm._v(" "), (!_vm.hasPriceErrors && !_vm.hasPriceErrorsDueResources) ? _c('div', {
    staticClass: "mt-4 ml-1 d-flex justify-content-start align-items-center"
  }, [_c('i', {
    staticClass: "fa fa-info-circle fs-large color-6 mr-2"
  }), _vm._v(" "), _c('span', {
    staticClass: "mb-0 fs-small color-6 bold"
  }, [_vm._v(_vm._s(_vm.importantNote))])]) : _vm._e(), _vm._v(" "), (_vm.hasPriceErrors && !_vm.hasPriceErrorsDueResources) ? _c('div', {
    staticClass: "error mt-3 d-flex justify-content-center"
  }, [_c('i', {
    staticClass: "fas fa-exclamation-triangle fs-large color-6 mr-2"
  }), _vm._v(" "), _c('span', {
    staticClass: "mb-0 fs-small color-6 bold"
  }, [_vm._v(_vm._s(_vm.priceErrorMessage))])]) : _vm._e(), _vm._v(" "), (_vm.hasPriceErrorsDueResources) ? _c('div', {
    staticClass: "error mt-3 d-flex justify-content-center"
  }, [_c('i', {
    staticClass: "fas fa-exclamation-triangle fs-large color-6 mr-2"
  }), _vm._v(" "), _c('span', {
    staticClass: "mb-0 fs-small color-6 bold"
  }, [_vm._v(_vm._s(_vm.resourcesPriceErrorMessage))])]) : _vm._e()])]), _vm._v(" "), _c('h5', {
    staticClass: "my-4 p-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "row mx-1"
  }, [_c('div', {
    staticClass: "col-12 mb-3"
  }, [_c('label', {
    staticClass: "full my-2 fs-large darker"
  }, [_vm._v("This group includes:")]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3 mx-0 justify-content-between"
  }, _vm._l((_vm.audienceTypes), function(genderPrice, idx) {
    return _c('div', {
      key: genderPrice.id,
      staticClass: "col-12 col-sm-6 col-md-5 col-lg-5 col-xl-4 col-xxl-3 p-0 d-flex align-items-start mb-2"
    }, [_c('div', {
      staticClass: "checkbox-component",
      class: {
        'pointer': !_vm.disabled,
        'notAllowed': _vm.disabled || !_vm.hasOnlyOneGenderPrice && _vm.getAudienceTypeCheckboxValue(genderPrice)
      },
      staticStyle: {
        "display": "inline-flex",
        "align-items": "center",
        "white-space": "nowrap"
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "id": ("checkbox-id-" + idx),
        "disabled": _vm.disabled || !_vm.hasOnlyOneGenderPrice && _vm.getAudienceTypeCheckboxValue(genderPrice)
      },
      domProps: {
        "checked": _vm.getAudienceTypeCheckboxValue(genderPrice)
      },
      on: {
        "change": function($event) {
          return _vm.updateAudienceTypeCheckbox($event, genderPrice)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": ("checkbox-id-" + idx)
      }
    }, [_c('span', {
      staticClass: "input-box"
    }, [_c('svg', {
      staticClass: "input-box-tick",
      attrs: {
        "viewBox": "0 0 16 16"
      }
    }, [_c('path', {
      attrs: {
        "fill": "none",
        "d": "M1.7,7.8l3.8,3.4l9-8.8"
      }
    })])]), _vm._v("\n                            " + _vm._s(genderPrice.description) + "\n                        ")])]), _vm._v(" "), (_vm.validateGenderPriceDeps(genderPrice)) ? _c('i', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ('Dependencies'),
        expression: "'Dependencies'"
      }],
      staticClass: "fas fa-project-diagram fs-normal ml-2 medium mt-1 pointer",
      class: {
        'color-1': _vm.hasPriceDependencies(genderPrice),
        'notAllowed': _vm.disabled && !_vm.hasPriceDependencies(genderPrice)
      },
      on: {
        "click": function($event) {
          return _vm.openGenderPriceDeps(genderPrice)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isTierPrice(genderPrice) && _vm.group.passengerSettings.format === 2) ? _c('i', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ('Prices'),
        expression: "'Prices'"
      }],
      staticClass: "fas fa-cog ml-1 pointer darkest fs-large",
      on: {
        "click": function($event) {
          return _vm.activateCategoryPrices(genderPrice)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isSameHash(genderPrice) && _vm.group.passengerSettings.format === 2) ? _c('i', {
      staticClass: "fas fa-check-circle ml-1 pointer color-3 fs-smallest check-icon-position"
    }) : _vm._e()])
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00d3698c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/products/components/pricingManager/PricePerGroup.vue
// module id = 1376
// module chunks = 0